import { SurchargeTranslation } from "./surcharge-translation.model";

export class SurchargeTranslationMapper {
  public static map(data: any): SurchargeTranslation {
    if (!data) {
      return;
    }

    return new SurchargeTranslation(
      data.locale,
      data.name,
      data.externalDescription,
    );
  }
}
